// extracted by mini-css-extract-plugin
export var auto = "_3m-1";
export var spinner = "_3m-0";